<template>
    <div>
        <v-card style="" class="pb-3 pt-0 px-2 account-callback-requests">
            <v-layout
                v-if="!callbackRequests.length"
                justify-center
                align-center
                class="mt-5 headline"
            >
                No Callback Requests
            </v-layout>
            <div v-for="callbackRequest in callbackRequests">
                <v-card
                    v-if="!callbackRequest.editing"
                    class="pb-4 pt-2 px-3 my-3"
                    style="cursor: pointer;"
                    @click="editCallback(callbackRequest)"
                >
                    <v-layout row class="mb-2">
                        <v-btn
                            @click="editCallback(callbackRequest)"
                            flat
                            icon
                            class="mb-0 mt-1 mx-2"
                            color="#999"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                        <div class="mt-3">
                            {{ callbackRequest.dateTime | time }}
                        </div>
                        <v-spacer></v-spacer>
                        <div class="mt-3 body-2">
                            Assigned To: {{ callbackRequest.assignedTo }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                            v-bind:class="{
                                'callback-request-status-pending':
                                    callbackRequest.status == 'PENDING',
                                'callback-request-status-completed':
                                    callbackRequest.status != 'PENDING',
                            }"
                            class="px-2 py-1"
                            style="color: #fff; height: 33px"
                        >
                            {{ callbackRequest.status }}
                        </div>
                    </v-layout>
                    <v-layout row wrap class="ml-2">{{
                        callbackRequest.note
                    }}</v-layout>
                </v-card>
                <v-card
                    v-if="callbackRequest.editing"
                    class="pb-4 pt-2 px-3 my-3"
                >
                    <v-layout row justify-end class="mb-2">
                        <div
                            v-bind:class="{
                                'callback-request-status-pending':
                                    callbackRequest.status == 'PENDING',
                                'callback-request-status-completed':
                                    callbackRequest.status != 'PENDING',
                            }"
                            style="color: #fff"
                            class="px-2 py-1"
                        >
                            {{ callbackRequest.status }}
                        </div>
                    </v-layout>
                    <v-layout row justify-space-between>
                        <div class="px-2 ml-1">
                            <v-layout row class="mb-2 pl-3">
                                <div class="width-200 font-weight-medium">
                                    Date:
                                </div>
                                <div>{{ callbackRequest.dateTime | time }}</div>
                            </v-layout>
                            <v-layout
                                row
                                class="mb-2 pl-3"
                                v-if="callbackRequest.completedAt"
                            >
                                <div class="width-200 font-weight-medium">
                                    Completed At:
                                </div>
                                <div>
                                    {{ callbackRequest.completedAt | time }}
                                </div>
                            </v-layout>
                            <v-layout row class="my-2 pl-3">
                                <div class="width-200 font-weight-medium">
                                    Caller ID:
                                </div>
                                <div>
                                    {{
                                        formatPhoneNumber(
                                            callbackRequest.callerID,
                                        )
                                    }}
                                </div>
                            </v-layout>
                            <v-layout row class="my-2 pl-3">
                                <div class="width-200 font-weight-medium">
                                    Callback Number:
                                </div>
                                <div>
                                    {{
                                        formatPhoneNumber(
                                            callbackRequest.callbackNumber,
                                        )
                                    }}
                                </div>
                            </v-layout>
                            <v-layout row class="my-2 pl-3">
                                <div class="width-200 font-weight-medium">
                                    Phone Line:
                                </div>
                                <div>
                                    {{ callbackRequest.phoneLine }}
                                </div>
                            </v-layout>
                            <v-layout row class="my-2 pl-3">
                                <div class="width-200 font-weight-medium">
                                    Assigned To:
                                </div>
                                <div>{{ callbackRequest.assignedTo }}</div>
                            </v-layout>
                            <v-layout
                                row
                                class="my-2 pl-3"
                                v-if="callbackRequest.recording"
                            >
                                <div class="width-200 font-weight-medium">
                                    Message:
                                </div>
                                <audio-player
                                    :src="callbackRequest.recording"
                                ></audio-player>
                            </v-layout>
                            <div
                                v-if="callbackRequest.recordingUpdatedAt"
                                class="mb-3 pl-1 text-danger body-2"
                            >
                                Recording Updated At
                                {{ callbackRequest.recordingUpdatedAt | time }}
                            </div>
                        </div>
                        <v-layout row justify-end align-end>
                            <v-btn
                                small
                                class="mr-2 mb-4"
                                @click="
                                    openUnassignCallbackDialog(callbackRequest)
                                "
                                v-if="
                                    callbackRequest.assignedTo !=
                                        'Unassigned' &&
                                        callbackRequest.status != 'COMPLETED'
                                "
                                color="default"
                                dark
                                >Unassign Callback</v-btn
                            >
                            <v-btn
                                :disabled="!allowCall(callbackRequest)"
                                small
                                class="mr-4 mb-4"
                                @click="openMakeCallDialog(callbackRequest)"
                                color="success"
                                >Call</v-btn
                            >
                        </v-layout>
                    </v-layout>
                    <v-textarea
                        class="mx-0 mt-0 mb-0"
                        hide-details
                        label="Note"
                        v-model="callbackRequest.note"
                        ref="note"
                        rows="4"
                        outline
                        font-weight-medium
                    ></v-textarea>
                    <v-card-actions class="mx-0 pb-0">
                        <v-checkbox
                            class="mx-0 my-0"
                            hide-details
                            color="success"
                            label="Mark as Completed"
                            v-model="callbackRequest.markAsCompleted"
                        ></v-checkbox>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="default"
                            dark
                            small
                            @click.stop="rollbackCallback(callbackRequest)"
                            >Cancel</v-btn
                        >
                        <v-btn
                            color="success"
                            :loading="processing"
                            small
                            @click="save(callbackRequest)"
                            >Save</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </div>
        </v-card>
        <v-dialog persistent v-model="makeCallDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Call {{ name }}</v-card-title
                >
                <!-- <v-select
                    class="mx-2"
                    :items="fromPhones"
                    label="From"
                    ref="from"
                    v-model="makeCallDetails.from"
                    :rules="[rules.required]"
                    @change="updateInternalNumber"
                    item-text="`${formatPhoneNumber(data.item.number)} - ${data.item.description}` "
                >
                    <template slot="selection" slot-scope="data">
                        {{
                            formatPhoneNumber(data.item.number) +
                                " - " +
                                data.item.description
                        }}
                    </template>
                    <template slot="item" slot-scope="data">
                        <v-list-tile-content>
                            <v-list-tile-title
                                v-html="
                                    `${formatPhoneNumber(data.item.number)} - ${
                                        data.item.description
                                    }`
                                "
                            >
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </template>
                </v-select> -->
                <v-text-field
                    class="mx-2"
                    label="From"
                    v-model="makeCallDetails.from"
                    ref="from"
                    :rules="[rules.required, rules.phone]"
                ></v-text-field>
                <!-- <v-text-field
                    class="mx-2"
                    label="Caller ID"
                    v-model="makeCallDetails.callerID"
                    ref="callerID"
                    :rules="[rules.required, rules.phone]"
                ></v-text-field> -->
                <!-- <v-text-field
                    class="mx-2"
                    label="To"
                    v-model="makeCallDetails.to"
                    ref="to"
                    :rules="[rules.required, rules.phone]"
                ></v-text-field> -->
                <v-select
                    class="mx-2"
                    :items="accountPhones"
                    label="To"
                    ref="to"
                    v-model="makeCallDetails.to"
                ></v-select>
                <v-text-field
                    class="mx-2"
                    label="Internal Number"
                    v-model="makeCallDetails.internalNumber"
                    ref="internalNumber"
                    :rules="[rules.required, rules.phone]"
                ></v-text-field>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="makeCallDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="calling"
                        color="success"
                        @click="makeCall()"
                    >
                        Call
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="unassignCallbackDialog" max-width="500">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 text-warning"
                    >Are you sure?</v-card-title
                >
                <div class="mb-2">
                    This will unassign the callback request from
                    {{ unassignCallback.assignedTo }}
                </div>
                <v-layout
                    row
                    class="mt-3 px-3 py-2"
                    style="border: 2px solid #4caf50; border-radius: 10px;"
                    v-if="action != 'assign'"
                >
                    <div class="mr-3 pt-3 my-2">Assign To Someone Else?</div>

                    <v-autocomplete
                        class="my-2"
                        hide-details
                        label="Assigned To"
                        placeholder="Start typing..."
                        hide-no-data
                        ref="assignToUser"
                        v-model="assignToUser"
                        :items="users"
                        :search-input.sync="loadUsers"
                    ></v-autocomplete>
                </v-layout>
                <v-card-actions class="mx-0 px-2 pb-2 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        :disabled="processing"
                        @click="unassignCallbackDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="unassign()"
                    >
                        Unassign
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { formatPhoneNumber } from "../../utils/helpers.js";
export default {
    props: {
        accountID: String,
        name: String,
        goToCallbackSection: Boolean,
        loadCallbackRequests: Function,
        callbackRequests: Array,
    },
    data() {
        return {
            note: "",

            processing: false,
            calling: false,

            makeCallCallback: "",
            makeCallDialog: false,
            makeCallDetails: {
                from: "",
                callerID: "",
                to: "",
                internalNumber: "",
                accountId: "",
                username: "",
            },

            unassignCallbackDialog: false,
            unassignCallback: "",

            accountPhones: [],

            fromPhones: [],

            users: [],
            loadUsers: null,
            assignToUser: "",

            rules: {
                required: (value) => !!value || "Required.",
                phone: (v) => {
                    return (
                        !v ||
                        ([10, 11].includes(v.trim().replace(/-/g, "").length) &&
                            /^\d+$/.test(v.trim().replace(/-/g, ""))) ||
                        "A Valid Phone Number Is Required."
                    );
                },
            },
        };
    },
    watch: {
        // accountID(newValue, oldValue) {
        //     if (newValue) {
        //         this.loadCallbackRequests();
        //     }
        // },
        async loadUsers(value) {
            if (!value) return;

            const response = await this.$http.get(
                `/odata/users?$count=true&$filter=(contains(userName, '${value.trim()}'))`,
            );

            this.users = response.value.map((u) => u.userName);
        },
    },
    async created() {
        this.loadFromPhones();
        this.loadAccountPhones();
    },
    mounted() {},
    beforeDestroy() {},
    computed: {},
    methods: {
        async loadFromPhones() {
            this.fromPhones = await this.$http.get("api/broadcast/get");
        },
        updateInternalNumber(value) {
            this.makeCallDetails.internalNumber = value.forwardNumber;
            this.makeCallDetails.callerID = value.number;
        },
        async loadAccountPhones() {
            const accountPhones = await this.$http.get(
                "api/broadcast/getAccountPhones?accountID=" +
                    this.accountID +
                    "&all=true",
            );

            this.accountPhones = accountPhones.map(
                (p) => p.phoneNum + " (" + p.phoneType + ")",
            );
        },
        formatPhoneNumber(value) {
            return formatPhoneNumber(value);
        },
        allowCall(callback) {
            return callback.assignedTo == this.$store.state.authentication.user;
        },
        editCallback(callback) {
            callback.originalNote = callback.note;
            callback.editing = true;
        },
        rollbackCallback(callback) {
            callback.note = callback.originalNote;
            callback.editing = false;
        },
        openMakeCallDialog(callback) {
            const callbackNumber =
                callback.callbackNumber.length == 11
                    ? callback.callbackNumber
                    : "1" + callback.callbackNumber;

            const accountPhone = this.accountPhones.find((phone) => {
                const parts = phone.split(" ");

                return parts[0] == callbackNumber;
            });

            if (!accountPhone) {
                this.accountPhones.push(callbackNumber);
                this.makeCallDetails.to = callbackNumber;
            } else {
                this.makeCallDetails.to = accountPhone;
            }

            this.makeCallDetails.from = "17189639260";
            this.makeCallCallback = callback;

            const savedInternalNumber = localStorage.getItem(
                "user-internal-number",
            );

            this.makeCallDetails.internalNumber = savedInternalNumber;

            if (!savedInternalNumber) {
                this.makeCallDetails.internalNumber = this.$store.getters[
                    "authentication/getUtaPhone"
                ];
            }

            this.makeCallDialog = true;
        },
        async openUnassignCallbackDialog(callbackRequest) {
            this.unassignCallbackDialog = true;
            this.unassignCallback = callbackRequest;

            const response = await this.$http.get(`/odata/users?$count=true`);

            this.users = response.value.map((u) => u.userName);
        },
        validate() {
            return [
                this.$refs.from.validate(true),
                this.$refs.to.validate(true),
                this.$refs.internalNumber.validate(true),
            ].every(Boolean);
        },
        cleanPhoneNumber(phoneNumber) {
            if (!phoneNumber) return;

            const value = phoneNumber.trim().replace(/-/g, "");

            return value.length < 11 ? "1" + value : value;
        },
        getToNumber() {
            const parts = this.makeCallDetails.to.split(" ");
            const toNumber = parts[0];

            return toNumber.length < 11 ? "1" + toNumber : toNumber;
        },
        async makeCall() {
            if (!this.validate()) return;

            this.calling = true;

            try {
                await this.$http.post("api/broadcast/makeCall", {
                    from: this.cleanPhoneNumber(this.makeCallDetails.from),
                    to: this.getToNumber(),
                    callerID: this.cleanPhoneNumber(this.makeCallDetails.from),
                    internalNumber: this.cleanPhoneNumber(
                        this.makeCallDetails.internalNumber,
                    ),
                    accountID: this.accountID,
                    username: this.$store.state.authentication.user,
                });

                localStorage.setItem(
                    "user-internal-number",
                    this.cleanPhoneNumber(this.makeCallDetails.internalNumber),
                );

                this.calling = false;
                this.makeCallDialog = false;
            } catch (e) {
                this.calling = false;
            }
        },
        async unassign() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/Communications/UnassignCallback?callbackRequestID=",
                    {
                        callbackRequestID: this.unassignCallback
                            .callbackRequestID,
                        assignedToUser: this.assignToUser
                            ? this.assignToUser
                            : null,
                    },
                );

                this.processing = false;
                this.unassignCallbackDialog = false;
                this.assignToUser = "";

                this.loadCallbackRequests();
            } catch (e) {
                this.processing = false;
            }
        },
        async save(callback) {
            if (callback.markAsCompleted && !callback.note) {
                this.$notify({
                    text:
                        "You can't mark as completed without entering a note.",
                    group: "notification",
                    type: "error",
                });

                return;
            }

            this.processing = true;

            try {
                await this.$http.post(
                    "api/Communications/UpdateCommunication",
                    {
                        note: callback.note,
                        status: callback.markAsCompleted
                            ? "COMPLETED"
                            : "PENDING",
                        communicationID: callback.id,
                        callbackID: callback.callbackRequestID,
                        user: this.$store.state.authentication.user,
                    },
                );

                this.processing = false;

                this.loadCallbackRequests();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.account-callback-requests {
    background-color: #f1ffdc !important;
    height: 550px;
    overflow-y: auto;
}
.callback-request-status-pending {
    background-color: #fdb400;
}
.callback-request-status-completed {
    background-color: #4caf50;
}
</style>
